import * as React from 'react';
import {FunctionComponent} from 'react';
import {Slide as SpectacleSlide} from 'spectacle';

interface OwnProps {
    major?: boolean;
}

export const Slide: FunctionComponent<OwnProps> = ({children, major}) => {
    return (
        <SpectacleSlide bgColor="primary">
            {children}
            <img
                src={require('../images/logo.svg')}
                width={100}
                style={{position: 'fixed', top: '100px', right: '100px'}}
            />
            {major === true ? (
                <img
                    src={require('../images/logo.png')}
                    width={500}
                    style={{position: 'fixed', bottom: '0', right: '0'}}
                />
            ) : null}
        </SpectacleSlide>
    );
};
